// import { useState } from 'react';

// export default function ChecklistSection() {
//   const [mode, setMode] = useState('advanced'); // 'advanced' | 'simple'
//   const [currentStage, setCurrentStage] = useState(0);
//   const [stages, setStages] = useState([
//     {
//       name: 'Planning',
//       icon: '🔓',
//       progress: 0,
//       total: 3,
//       items: [
//         { text: 'Requirements gathered', done: false, assignee: 'Sarah', comments: 3, status: 'in-progress' },
//         { text: 'Stakeholders identified', done: false, assignee: 'Mike', comments: 1 },
//         { text: 'Timeline confirmed', done: false, date: '2024-12-20' },
//       ],
//     },
//     {
//       name: 'Development',
//       icon: '🔒',
//       progress: 0,
//       total: 4,
//       items: [],
//     },
//     {
//       name: 'Testing',
//       icon: '🔒',
//       progress: 0,
//       total: 3,
//       items: [],
//     },
//     {
//       name: 'Deployment',
//       icon: '🔒',
//       progress: 0,
//       total: 3,
//       items: [],
//     },
//   ]);

//   const toggleItem = (stageIndex, itemIndex) => {
//     setStages((prev) =>
//       prev.map((stage, sIdx) =>
//         sIdx === stageIndex
//           ? {
//               ...stage,
//               items: stage.items.map((item, i) =>
//                 i === itemIndex ? { ...item, done: !item.done } : item
//               ),
//               progress: Math.round(
//                 (stage.items.filter((i) => i.done).length / stage.items.length) * 100
//               ) || 0,
//             }
//           : stage
//       )
//     );

//     // Simple auto-progress simulation (unlock next stage when current is 100%)
//     if (stages[stageIndex].progress === 100 && currentStage === stageIndex) {
//       if (stageIndex + 1 < stages.length) {
//         setCurrentStage(stageIndex + 1);
//       }
//     }
//   };

//   const totalOverallProgress = Math.round(
//     stages.reduce((sum, s) => sum + s.progress, 0) / stages.length
//   );

//   return (
//     <section className="checklist-section">
//       <div className="gradient-bg" />
//       <div className="content-wrapper">
//         {/* Header */}
//         <div className="header">
//           <div className="pill">
//             <span className="icon">✓</span> Multi-Stage Checklists
//           </div>
//           <h2>Break Down Complex Tasks</h2>
//           <p>
//             Two powerful checklist types. One platform. Choose advanced execution tracking with stages, or simple lists for quick tasks.
//           </p>
//         </div>

//         {/* Mode Switch */}
//         <div className="mode-switch">
//           <button
//             className={`btn ${mode === 'advanced' ? 'active' : ''}`}
//             onClick={() => setMode('advanced')}
//           >
//             <span className="icon">🚀</span>
//             <div>
//               <div className="title">Advanced Execution</div>
//               <div className="subtitle">Multi-stage workflows</div>
//             </div>
//           </button>

//           <button
//             className={`btn ${mode === 'simple' ? 'active' : ''}`}
//             onClick={() => setMode('simple')}
//           >
//             <span className="icon">✓</span>
//             <div>
//               <div className="title">Normal Checklist</div>
//               <div className="subtitle">Simple & focused</div>
//             </div>
//           </button>
//         </div>

//         {/* Live Demo Area */}
//         {mode === 'advanced' ? (
//           <div className="demo-card">
//             <div className="demo-header">
//               <div className="left">
//                 <div className="logo">⚡</div>
//                 <div>
//                   <h3>Advanced Execution Demo</h3>
//                   <p>Try adding stages, completing items, watching auto-progression</p>
//                 </div>
//               </div>
//               <div className="badge">Fully Interactive</div>
//             </div>

//             {/* Global Progress */}
//             <div className="global-progress">
//               <span>{stages.filter(s => s.progress === 100).length}/{stages.length} Stages</span>
//               <div className="progress-bar">
//                 <div className="fill" style={{ width: `${totalOverallProgress}%` }} />
//               </div>
//               <span className="percent">{totalOverallProgress}%</span>
//             </div>

//             {/* Horizontal Stages Scroll */}
//             <div className="stages-scroll">
//               {stages.map((stage, idx) => (
//                 <button
//                   key={stage.name}
//                   className={`stage-btn ${idx === currentStage ? 'active' : ''} ${stage.progress === 100 ? 'completed' : ''} ${idx > currentStage ? 'locked' : ''}`}
//                   onClick={() => idx <= currentStage && setCurrentStage(idx)}
//                   disabled={idx > currentStage}
//                 >
//                   <span className="stage-icon">{idx === currentStage ? '🔓' : '🔒'}</span>
//                   <div className="stage-info">
//                     <div className="name">{stage.name}</div>
//                     <div className="progress-text">{stage.progress}% • {stage.items.filter(i => i.done).length}/{stage.total}</div>
//                   </div>
//                 </button>
//               ))}
//             </div>

//             {/* Current Stage Items */}
//             <div className="current-stage">
//               <h4>{stages[currentStage].name}</h4>
//               <div className="items-list">
//                 {stages[currentStage].items.map((item, i) => (
//                   <div
//                     key={i}
//                     className={`checklist-item ${item.done ? 'done' : ''}`}
//                     onClick={() => toggleItem(currentStage, i)}
//                   >
//                     <div className="checkbox">
//                       {item.done ? '✓' : ''}
//                     </div>

//                     <div className="content">
//                       <div className="text">{item.text}</div>
//                       {item.status && (
//                         <span className={`status-tag ${item.status}`}>{item.status}</span>
//                       )}
//                       <div className="meta">
//                         {item.assignee && <span className="assignee">@{item.assignee}</span>}
//                         {item.comments && <span className="comments">💬 {item.comments}</span>}
//                         {item.date && <span className="date">{item.date}</span>}
//                       </div>
//                     </div>

//                     <button className="delete-btn">×</button>
//                   </div>
//                 ))}

//                 <button className="add-item-btn">
//                   + Add item
//                 </button>
//               </div>
//             </div>

//             <button className="add-stage-btn">
//               + Add New Stage
//             </button>
//           </div>
//         ) : (
//           // Simple mode preview (you can expand later)
//           <div className="simple-preview">
//             <h3>Simple Checklist Example</h3>
//             <div className="simple-items">
//               {['Requirements gathered', 'Technical specs reviewed', 'Timeline confirmed', 'Team assigned'].map((text, i) => (
//                 <div key={i} className="simple-item">
//                   <input type="checkbox" id={`simple-${i}`} />
//                   <label htmlFor={`simple-${i}`}>{text}</label>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

import React, { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import {
  CheckSquare,
  CheckCircle2,
  Plus,
  Sparkles,
  Zap,
  Target,
  Rocket,
  Trophy,
  User,
  FileText,
  Star,
  Check,
} from "lucide-react";

import { MultiStageChecklistAdvanced } from "./MultiStageChecklistAdvanced";
// offcie_hub.css line  3749 to 4430
export default function ChecklistSection() {
  const [activeDemo, setActiveDemo] = useState("advanced");

  // Normal Checklist Demo State
  const [normalItems, setNormalItems] = useState([
    { id: 1, text: "Requirements gathered", completed: true, hasDetails: true },
    {
      id: 2,
      text: "Technical specs reviewed",
      completed: true,
      hasDetails: true,
    },
    { id: 3, text: "Timeline confirmed", completed: false, hasDetails: false },
    { id: 4, text: "Team assigned", completed: false, hasDetails: false },
  ]);

  // Normal checklist handlers
  const [newItemText, setNewItemText] = useState("");
  const [showAddInput, setShowAddInput] = useState(false);
  const [normalConfetti, setNormalConfetti] = useState(false);

  const toggleNormalItem = (id) => {
    const updatedItems = normalItems.map((i) =>
      i.id === id ? { ...i, completed: !i.completed } : i,
    );
    setNormalItems(updatedItems);

    if (
      updatedItems.length > 0 &&
      updatedItems.every((item) => item.completed)
    ) {
      setNormalConfetti(true);
      setTimeout(() => setNormalConfetti(false), 3000);
    }
  };

  const addNormalItem = () => {
    if (newItemText.trim()) {
      const newItem = {
        id: Math.max(...normalItems.map((i) => i.id), 0) + 1,
        text: newItemText.trim(),
        completed: false,
        hasDetails: false,
      };
      setNormalItems([...normalItems, newItem]);
      setNewItemText("");
      setShowAddInput(false);
    }
  };

  const getFeatureCardClass = (color) => {
    const base = "MultiStageChecklistSection_ClassV1_FeatureCard";
    const map = {
      cyan: `${base} ${base}__cyan`,
      purple: `${base} ${base}__purple`,
      blue: `${base} ${base}__blue`,
      amber: `${base} ${base}__amber`,
      green: `${base} ${base}__green`,
      pink: `${base} ${base}__pink`,
      gray: `${base} ${base}__gray`,
    };
    return map[color] || map.blue;
  };

  return (
    <section className="MultiStageChecklistSection_ClassV1_Section">
      {/* Background Elements */}
      {/* <div className="MultiStageChecklistSection_ClassV1_BgLayer">
        <div className="MultiStageChecklistSection_ClassV1_Blob MultiStageChecklistSection_ClassV1_Blob__Cyan" />
        <div className="MultiStageChecklistSection_ClassV1_Blob MultiStageChecklistSection_ClassV1_Blob__Blue" />
      </div> */}

      <div className="MultiStageChecklistSection_ClassV1_Container">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="MultiStageChecklistSection_ClassV1_Header"
        >
          <div className="MultiStageChecklistSection_ClassV1_Pill MultiStageChecklistSection_ClassV1_Pill__BlueCyan">
            <CheckSquare className="MultiStageChecklistSection_ClassV1_IconSm" />
            <span className="MultiStageChecklistSection_ClassV1_PillText">
              Multi-Stage Checklists
            </span>
          </div>

          <h2 className="MultiStageChecklistSection_ClassV1_Title">
            Break Down Complex Tasks
          </h2>

          <p className="MultiStageChecklistSection_ClassV1_SubTitle">
            Two powerful checklist types. One platform. Choose advanced
            execution tracking with stages, or simple lists for quick tasks.
            Both packed with features.
          </p>
        </motion.div>

        {/* Type Selector */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="MultiStageChecklistSection_ClassV1_SelectorRow"
        >
          <div className="MultiStageChecklistSection_ClassV1_SelectorWrap">
            <button
              onClick={() => setActiveDemo("advanced")}
              className={
                activeDemo === "advanced"
                  ? "MultiStageChecklistSection_ClassV1_ToggleBtn MultiStageChecklistSection_ClassV1_ToggleBtn__Active"
                  : "MultiStageChecklistSection_ClassV1_ToggleBtn MultiStageChecklistSection_ClassV1_ToggleBtn__Inactive"
              }
            >
              <Rocket className="MultiStageChecklistSection_ClassV1_IconSm" />
              <div className="MultiStageChecklistSection_ClassV1_ToggleText">
                <div className="MultiStageChecklistSection_ClassV1_ToggleTitle">
                  Advanced Execution
                </div>
                <div
                  className={
                    activeDemo === "advanced"
                      ? "MultiStageChecklistSection_ClassV1_ToggleSub MultiStageChecklistSection_ClassV1_ToggleSub__Active"
                      : "MultiStageChecklistSection_ClassV1_ToggleSub MultiStageChecklistSection_ClassV1_ToggleSub__Inactive"
                  }
                >
                  Multi-stage workflows
                </div>
              </div>
            </button>

            <button
              onClick={() => setActiveDemo("normal")}
              className={
                activeDemo === "normal"
                  ? "MultiStageChecklistSection_ClassV1_ToggleBtn MultiStageChecklistSection_ClassV1_ToggleBtn__Active"
                  : "MultiStageChecklistSection_ClassV1_ToggleBtn MultiStageChecklistSection_ClassV1_ToggleBtn__Inactive"
              }
            >
              <CheckCircle2 className="MultiStageChecklistSection_ClassV1_IconSm" />
              <div className="MultiStageChecklistSection_ClassV1_ToggleText">
                <div className="MultiStageChecklistSection_ClassV1_ToggleTitle">
                  Normal Checklist
                </div>
                <div
                  className={
                    activeDemo === "normal"
                      ? "MultiStageChecklistSection_ClassV1_ToggleSub MultiStageChecklistSection_ClassV1_ToggleSub__Active"
                      : "MultiStageChecklistSection_ClassV1_ToggleSub MultiStageChecklistSection_ClassV1_ToggleSub__Inactive"
                  }
                >
                  Simple & focused
                </div>
              </div>
            </button>
          </div>
        </motion.div>

        {/* Unified Demo Section */}
        <AnimatePresence mode="wait">
          {activeDemo === "advanced" ? (
            <motion.div
              key="advanced-full"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -40 }}
              transition={{ duration: 0.5 }}
            >
              <div className="MultiStageChecklistSection_ClassV1_DemoIntro">
                <div className="MultiStageChecklistSection_ClassV1_Pill MultiStageChecklistSection_ClassV1_Pill__PurplePink">
                  <Sparkles className="MultiStageChecklistSection_ClassV1_IconSm" />
                  <span className="MultiStageChecklistSection_ClassV1_PillText">
                    Live Interactive Demo
                  </span>
                </div>

                <h3 className="MultiStageChecklistSection_ClassV1_H3">
                  Experience Advanced Execution
                </h3>

                <p className="MultiStageChecklistSection_ClassV1_SubTitle">
                  Click items, add stages, watch confetti burst when stages
                  complete. This is the actual component with all the magic
                  micro-interactions.
                </p>
              </div>

              {/* Full Premium Demo */}
              <div className="MultiStageChecklistSection_ClassV1_PremiumCard">
                <div className="MultiStageChecklistSection_ClassV1_PremiumInner">
                  {/* Demo Header */}
                  <div className="MultiStageChecklistSection_ClassV1_PremiumHeader">
                    <div className="MultiStageChecklistSection_ClassV1_PremiumHeaderRow">
                      <div className="MultiStageChecklistSection_ClassV1_PremiumHeaderLeft">
                        <div className="MultiStageChecklistSection_ClassV1_PremiumIconBox">
                          <Zap className="MultiStageChecklistSection_ClassV1_IconLg MultiStageChecklistSection_ClassV1_IconWhite" />
                        </div>
                        <div>
                          <h4 className="MultiStageChecklistSection_ClassV1_H4White">
                            Advanced Execution Demo
                          </h4>
                          <p className="MultiStageChecklistSection_ClassV1_WhiteSoft">
                            Try adding stages, completing items, and watching
                            auto-progression
                          </p>
                        </div>
                      </div>

                      <div className="MultiStageChecklistSection_ClassV1_PremiumBadge">
                        <div className="MultiStageChecklistSection_ClassV1_CyanMini">
                          Fully Interactive
                        </div>
                        <div className="MultiStageChecklistSection_ClassV1_WhiteSmall">
                          Click anything!
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* The actual premium component */}
                  <div className="MultiStageChecklistSection_ClassV1_ComponentWrap">
                    <MultiStageChecklistAdvanced
                      taskId="premium-demo"
                      viewMode="full"
                    />
                  </div>

                  {/* Feature Grid */}
                  <div className="MultiStageChecklistSection_ClassV1_TipGrid">
                    {[
                      {
                        icon: (
                          <Target className="MultiStageChecklistSection_ClassV1_IconSm" />
                        ),
                        title: "Auto-Progression",
                        description: "Complete all items to unlock next stage",
                      },
                      {
                        icon: (
                          <Sparkles className="MultiStageChecklistSection_ClassV1_IconSm" />
                        ),
                        title: "Confetti Celebration",
                        description: "Stage completion triggers animations",
                      },
                      {
                        icon: (
                          <Rocket className="MultiStageChecklistSection_ClassV1_IconSm" />
                        ),
                        title: "Smart Templates",
                        description: "Click Templates for instant workflows",
                      },
                      {
                        icon: (
                          <Star className="MultiStageChecklistSection_ClassV1_IconSm" />
                        ),
                        title: "Rich Items",
                        description: "Expand items to see all features",
                      },
                    ].map((tip, index) => (
                      <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 + 0.3 }}
                        className="MultiStageChecklistSection_ClassV1_TipCard"
                      >
                        <div className="MultiStageChecklistSection_ClassV1_TipIcon">
                          {tip.icon}
                        </div>
                        <h5 className="MultiStageChecklistSection_ClassV1_TipTitle">
                          {tip.title}
                        </h5>
                        <p className="MultiStageChecklistSection_ClassV1_TipDesc">
                          {tip.description}
                        </p>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ) : (
            <motion.div
              key="normal-full"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -40 }}
              transition={{ duration: 0.5 }}
            >
              <div className="MultiStageChecklistSection_ClassV1_DemoIntro">
                <div className="MultiStageChecklistSection_ClassV1_Pill MultiStageChecklistSection_ClassV1_Pill__GreenCyan">
                  <CheckCircle2 className="MultiStageChecklistSection_ClassV1_IconSm" />
                  <span className="MultiStageChecklistSection_ClassV1_PillText">
                    Simple Checklist Demo
                  </span>
                </div>

                <h3 className="MultiStageChecklistSection_ClassV1_H3">
                  Simple Yet Powerful
                </h3>

                <p className="MultiStageChecklistSection_ClassV1_SubTitle">
                  Sometimes you just need a checklist. But even our simple mode
                  is packed with assignees, documents, comments, and sub-items.
                </p>
              </div>

              {/* Normal Checklist Demo */}
              <div className="MultiStageChecklistSection_ClassV1_NormalWrap">
                {/* Confetti Celebration */}
                <AnimatePresence>
                  {normalConfetti && (
                    <div className="MultiStageChecklistSection_ClassV1_NormalConfetti">
                      {[...Array(50)].map((_, i) => (
                        <motion.div
                          key={i}
                          className="MultiStageChecklistSection_ClassV1_ConfettiDot"
                          style={{
                            left: `${Math.random() * 100}%`,
                            top: "-5%",
                            background: [
                              "#06B6D4",
                              "#22D3EE",
                              "#10B981",
                              "#F59E0B",
                              "#EC4899",
                            ][Math.floor(Math.random() * 5)],
                          }}
                          initial={{ y: 0, opacity: 1, rotate: 0 }}
                          animate={{
                            y: 800,
                            opacity: 0,
                            rotate: Math.random() * 360,
                            x: (Math.random() - 0.5) * 200,
                          }}
                          transition={{
                            duration: 2 + Math.random(),
                            ease: "easeOut",
                          }}
                        />
                      ))}
                    </div>
                  )}
                </AnimatePresence>

                <div className="MultiStageChecklistSection_ClassV1_NormalCard">
                  <div className="MultiStageChecklistSection_ClassV1_NormalHeaderRow">
                    <div>
                      <h3 className="MultiStageChecklistSection_ClassV1_H3Small">
                        Marketing Campaign
                      </h3>
                      <p className="MultiStageChecklistSection_ClassV1_MutedSm">
                        Normal Checklist
                      </p>
                    </div>

                    <div className="MultiStageChecklistSection_ClassV1_CompletedBadge">
                      <CheckCircle2 className="MultiStageChecklistSection_ClassV1_IconXs MultiStageChecklistSection_ClassV1_IconGreen" />
                      <span className="MultiStageChecklistSection_ClassV1_CompletedText">
                        {normalItems.filter((i) => i.completed).length}/
                        {normalItems.length}
                      </span>
                    </div>
                  </div>

                  {/* Completion Celebration Banner */}
                  <AnimatePresence>
                    {normalConfetti && (
                      <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: -10 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: -10 }}
                        className="MultiStageChecklistSection_ClassV1_CelebrationBanner"
                      >
                        <div className="MultiStageChecklistSection_ClassV1_CelebrationRow">
                          <Trophy className="MultiStageChecklistSection_ClassV1_IconSm" />
                          <span className="MultiStageChecklistSection_ClassV1_CelebrationText">
                            All tasks completed! 🎉
                          </span>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  <div className="MultiStageChecklistSection_ClassV1_NormalList">
                    <AnimatePresence mode="popLayout">
                      {normalItems.map((item, index) => (
                        <motion.div
                          key={item.id}
                          initial={{ opacity: 0, y: 10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, x: -100 }}
                          transition={{ delay: index * 0.05 }}
                          layout
                          className={
                            item.completed
                              ? "MultiStageChecklistSection_ClassV1_NormalItem MultiStageChecklistSection_ClassV1_NormalItem__Done"
                              : "MultiStageChecklistSection_ClassV1_NormalItem MultiStageChecklistSection_ClassV1_NormalItem__Open"
                          }
                        >
                          <div className="MultiStageChecklistSection_ClassV1_NormalItemRow">
                            <motion.button
                              type="button"
                              onClick={() => toggleNormalItem(item.id)}
                              whileTap={{ scale: 0.9 }}
                              className={
                                item.completed
                                  ? "MultiStageChecklistSection_ClassV1_NormalCheck MultiStageChecklistSection_ClassV1_NormalCheck__On"
                                  : "MultiStageChecklistSection_ClassV1_NormalCheck MultiStageChecklistSection_ClassV1_NormalCheck__Off"
                              }
                            >
                              <AnimatePresence>
                                {item.completed && (
                                  <motion.div
                                    initial={{ scale: 0, rotate: -90 }}
                                    animate={{ scale: 1, rotate: 0 }}
                                    exit={{ scale: 0, rotate: 90 }}
                                  >
                                    <Check
                                      className="MultiStageChecklistSection_ClassV1_IconXs MultiStageChecklistSection_ClassV1_IconWhite"
                                      strokeWidth={3}
                                    />
                                  </motion.div>
                                )}
                              </AnimatePresence>
                            </motion.button>

                            <div className="MultiStageChecklistSection_ClassV1_NormalTextWrap">
                              <div
                                className={
                                  item.completed
                                    ? "MultiStageChecklistSection_ClassV1_NormalText MultiStageChecklistSection_ClassV1_NormalText__Done"
                                    : "MultiStageChecklistSection_ClassV1_NormalText MultiStageChecklistSection_ClassV1_NormalText__Open"
                                }
                              >
                                {item.text}
                              </div>

                              {item.hasDetails && (
                                <div className="MultiStageChecklistSection_ClassV1_NormalMeta">
                                  <div className="MultiStageChecklistSection_ClassV1_MetaChip">
                                    <User className="MultiStageChecklistSection_ClassV1_Icon2xs" />
                                    Sarah
                                  </div>
                                  <div className="MultiStageChecklistSection_ClassV1_MetaChip">
                                    <FileText className="MultiStageChecklistSection_ClassV1_Icon2xs" />
                                    1 doc
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </motion.div>
                      ))}
                    </AnimatePresence>

                    {/* Add Item Input */}
                    <AnimatePresence mode="wait">
                      {showAddInput ? (
                        <motion.div
                          key="input"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          className="MultiStageChecklistSection_ClassV1_AddInputBox"
                        >
                          <input
                            type="text"
                            value={newItemText}
                            onChange={(e) => setNewItemText(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") addNormalItem();
                              if (e.key === "Escape") {
                                setShowAddInput(false);
                                setNewItemText("");
                              }
                            }}
                            placeholder="Type task name and press Enter..."
                            autoFocus
                            className="MultiStageChecklistSection_ClassV1_AddInput"
                          />

                          <div className="MultiStageChecklistSection_ClassV1_AddActions">
                            <button
                              type="button"
                              onClick={addNormalItem}
                              className="MultiStageChecklistSection_ClassV1_PrimaryBtn"
                            >
                              Add Task
                            </button>

                            <button
                              type="button"
                              onClick={() => {
                                setShowAddInput(false);
                                setNewItemText("");
                              }}
                              className="MultiStageChecklistSection_ClassV1_SecondaryBtn"
                            >
                              Cancel
                            </button>

                            <span className="MultiStageChecklistSection_ClassV1_HintText">
                              Press Enter ↵
                            </span>
                          </div>
                        </motion.div>
                      ) : (
                        <motion.button
                          key="button"
                          type="button"
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.95 }}
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => setShowAddInput(true)}
                          className="MultiStageChecklistSection_ClassV1_AddItemBtn"
                        >
                          <Plus className="MultiStageChecklistSection_ClassV1_IconXs" />
                          Add item
                        </motion.button>
                      )}
                    </AnimatePresence>
                  </div>

                  {/* Normal Checklist Features */}
                  <div className="MultiStageChecklistSection_ClassV1_NormalFooter">
                    <div className="MultiStageChecklistSection_ClassV1_FooterLabel">
                      Also includes:
                    </div>
                    <div className="MultiStageChecklistSection_ClassV1_TagWrap">
                      {[
                        "Actions",
                        "Documents",
                        "Comments",
                        "Status tags",
                        "Sub-items",
                      ].map((feature) => (
                        <div
                          key={feature}
                          className="MultiStageChecklistSection_ClassV1_Tag"
                        >
                          {feature}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Feature Highlights */}
                <div className="MultiStageChecklistSection_ClassV1_HighlightGrid">
                  {[
                    {
                      icon: (
                        <CheckCircle2 className="MultiStageChecklistSection_ClassV1_IconMd MultiStageChecklistSection_ClassV1_IconGreen" />
                      ),
                      title: "Clean & Simple",
                      description:
                        "No complexity. Just tasks that need to get done",
                      color: "green",
                    },
                    {
                      icon: (
                        <User className="MultiStageChecklistSection_ClassV1_IconMd MultiStageChecklistSection_ClassV1_IconBlue" />
                      ),
                      title: "Rich Details",
                      description:
                        "Add assignees, documents, and comments to any item",
                      color: "blue",
                    },
                    {
                      icon: (
                        <FileText className="MultiStageChecklistSection_ClassV1_IconMd MultiStageChecklistSection_ClassV1_IconPurple" />
                      ),
                      title: "Sub-Items",
                      description:
                        "Break down tasks into smaller actionable pieces",
                      color: "purple",
                    },
                  ].map((feature, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.1 + 0.3 }}
                      className={getFeatureCardClass(feature.color)}
                    >
                      <div className="MultiStageChecklistSection_ClassV1_FeatureIcon">
                        {feature.icon}
                      </div>
                      <h4 className="MultiStageChecklistSection_ClassV1_FeatureTitle">
                        {feature.title}
                      </h4>
                      <p className="MultiStageChecklistSection_ClassV1_FeatureDesc">
                        {feature.description}
                      </p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Feature Comparison */}
        <div className="MultiStageChecklistSection_ClassV1_Compare">
          <div className="MultiStageChecklistSection_ClassV1_CompareHeader">
            <div className="MultiStageChecklistSection_ClassV1_Pill MultiStageChecklistSection_ClassV1_Pill__BlueCyan">
              <CheckSquare className="MultiStageChecklistSection_ClassV1_IconSm" />
              <span className="MultiStageChecklistSection_ClassV1_PillText">
                Why Choose Checklists?
              </span>
            </div>

            <h3 className="MultiStageChecklistSection_ClassV1_H3">
              Powerful Features in Both Modes
            </h3>

            <p className="MultiStageChecklistSection_ClassV1_SubTitle">
              Whether you choose advanced or simple, you get professional-grade
              task execution tools.
            </p>
          </div>

          <div className="MultiStageChecklistSection_ClassV1_CompareGrid">
            {[
              {
                icon: (
                  <Target className="MultiStageChecklistSection_ClassV1_IconMd MultiStageChecklistSection_ClassV1_IconCyan" />
                ),
                title: "Auto-Progression",
                description: "Complete all items to unlock next stage",
                color: "cyan",
              },
              {
                icon: (
                  <Sparkles className="MultiStageChecklistSection_ClassV1_IconMd MultiStageChecklistSection_ClassV1_IconPurple" />
                ),
                title: "Confetti Celebration",
                description: "Stage completion triggers animations",
                color: "purple",
              },
              {
                icon: (
                  <Rocket className="MultiStageChecklistSection_ClassV1_IconMd MultiStageChecklistSection_ClassV1_IconAmber" />
                ),
                title: "Smart Templates",
                description: "Click Templates for instant workflows",
                color: "amber",
              },
              {
                icon: (
                  <Star className="MultiStageChecklistSection_ClassV1_IconMd MultiStageChecklistSection_ClassV1_IconGreen" />
                ),
                title: "Rich Items",
                description: "Expand items to see all features",
                color: "green",
              },
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className={getFeatureCardClass(feature.color)}
              >
                <div className="MultiStageChecklistSection_ClassV1_FeatureIcon">
                  {feature.icon}
                </div>
                <h5 className="MultiStageChecklistSection_ClassV1_FeatureTitle">
                  {feature.title}
                </h5>
                <p className="MultiStageChecklistSection_ClassV1_FeatureDesc">
                  {feature.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
